import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PopoverController } from "@ionic/angular";
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-tooltip-info-page-turn',
  templateUrl: './tooltip-info-page-turn.component.html',
  standalone: false
})
export class TooltipInfoPageTurnComponent implements OnInit, OnChanges {
  @Input() pageOrientation;
  longLottie;
  shortLottie;
  longLottieOptions: AnimationOptions;
  shortLottieOptions: AnimationOptions;

  constructor(private popoverController: PopoverController) {
  }

  ngOnInit() {

  }

  ngOnChanges(changes) {
    if (this.pageOrientation === 'vertical') {
      this.longLottie = 'assets/lotties/vertical-largo.json';
      this.shortLottie = 'assets/lotties/vertical-corto.json';
    } else {
      this.longLottie = 'assets/lotties/horizontal-largo.json';
      this.shortLottie = 'assets/lotties/horizontal-corto.json';
    }
    this.longLottieOptions = {
      path: this.longLottie,
      autoplay: true,
      loop: true,
    };
    this.shortLottieOptions = {
      path: this.shortLottie,
      autoplay: true,
      loop: true,
    };
    console.log('long', this.longLottie);
    console.log('short', this.shortLottie);
  }


}
